import i18n from "@/i18n.ts";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Input, Modal, ModalProps, useModals } from "@skailer-com/uikit";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as yup from "yup";

const buildItemSchema = () =>
  yup.object({
    title: yup.string().trim().required(i18n.t("errors:field_required")),
  });

type ItemSchema = yup.InferType<ReturnType<typeof buildItemSchema>>;

export interface OrganizationListItemEditModalProps extends ModalProps {
  itemTitle: string;
  onSave: (title: string) => void;
}

export function OrganizationListItemEditModal({
  itemTitle,
  onSave,
  ...props
}: OrganizationListItemEditModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = props;

  const itemSchema = buildItemSchema();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ItemSchema>({
    mode: "onSubmit",
    resolver: yupResolver(itemSchema),
    defaultValues: {
      title: itemTitle,
    },
  });

  const onSubmit = handleSubmit((data) => {
    onSave(data.title.trim());
    close(id);
  });

  return (
    <Modal
      {...props}
      title={itemTitle ? t("common:edit") : t("common:add_item")}
      withCloser
      closeByEscEnabled
      actions={
        <Button type="submit" size="lg" className="w-full" onClick={onSubmit}>
          {t("common:save")}
        </Button>
      }
    >
      <form onSubmit={onSubmit}>
        <Input
          label={t("common:title")}
          autoFocus
          type="text"
          {...register("title")}
          error={errors.title?.message}
        />
      </form>
    </Modal>
  );
}
